<template>
    <div>
        <h3 class="my-4">Ruta Protegida</h3>
        <p>Bienvenido {{ usuario.email }}</p>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Inicio',
    computed: {
        ...mapState(['usuario'])
    }
}
</script>